import React, { useEffect, useMemo, useState } from "react";
import api, { API } from "@/lib/api";
import { PageHeader, Card, Button, Input, Select, Field, Stat, Textarea } from "@/components/UI";
import { Plus, PencilSimple, Trash, ForkKnife, ArrowCounterClockwise, ChefHat, Book, FileXls, Printer } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { today, fmt, rid, EMPTY_RATION, EMPTY_CAT } from "./constants";

export function PrintableFeedList({ rations }) {
  // Collect unique feed names across all rations preserving order
  const seenNames = [];
  rations.forEach(r => (r.items || []).forEach(it => {
    if (it.name && !seenNames.includes(it.name)) seenNames.push(it.name);
  }));

  return (
    <div className="printable-only" data-testid="rations-printable">
      <h1 style={{ fontSize: 18, fontWeight: 700, marginBottom: 6 }}>
        YEM HAZIRLAMA LİSTESİ — {today()}
      </h1>
      <p style={{ fontSize: 11, color: "#555", marginBottom: 12 }}>
        Her hücre grup toplam kg değerini gösterir (kg/baş × hayvan sayısı).
      </p>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 11 }}>
        <thead>
          <tr>
            <th style={printThStyle}>YEM KALEMİ</th>
            {rations.map(r => {
              const eff = r.effective_animal_count ?? r.animal_count ?? 0;
              return (
                <th key={r.id} style={printThStyle}>
                  {r.name}
                  <div style={{ fontWeight: 400, fontSize: 10 }}>
                    ({eff} yemlenecek{r.feeding_animal_count && r.feeding_animal_count !== r.animal_count ? ` / ${r.animal_count} kayıtlı` : ""} baş)
                  </div>
                  {(r.meals_per_day > 1 || (r.meal_times && r.meal_times.length > 0)) && (
                    <div style={{ fontWeight: 400, fontSize: 9, opacity: 0.9 }}>
                      {r.meals_per_day || 2} öğün{r.meal_times && r.meal_times.length > 0 ? ` · ${r.meal_times.join(" · ")}` : ""}
                    </div>
                  )}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {seenNames.map(nm => (
            <tr key={nm}>
              <td style={{ ...printTdStyle, fontWeight: 600 }}>{nm}</td>
              {rations.map(r => {
                const it = (r.items || []).find(x => x.name === nm);
                const eff = r.effective_animal_count ?? r.animal_count ?? 0;
                const total = it ? (Number(it.amount_per_head_kg || 0) * eff) : 0;
                return (
                  <td key={r.id} style={{ ...printTdStyle, textAlign: "right" }}>
                    {total > 0 ? total.toLocaleString("tr-TR", { maximumFractionDigits: 2 }) : ""}
                  </td>
                );
              })}
            </tr>
          ))}
          <tr>
            <td style={{ ...printTdStyle, fontWeight: 700, background: "#F5F2EC" }}>TOPLAM (kg)</td>
            {rations.map(r => (
              <td key={r.id} style={{ ...printTdStyle, textAlign: "right", fontWeight: 700, background: "#F5F2EC" }}>
                {Number(r.total_kg || 0).toLocaleString("tr-TR", { maximumFractionDigits: 1 })}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
}

const printThStyle = { border: "1px solid #333", padding: "6px 8px", background: "#2D4A36", color: "#fff", fontWeight: 700, textAlign: "center" };

const printTdStyle = { border: "1px solid #ccc", padding: "4px 8px" };

// ---------------- RATIONS TAB ----------------
